import FeatureToBeImplementedSoonPage from "../../app/components/FeatureToBeImplementedSoonPage";

export default function MyOffers() {
  return (
   <FeatureToBeImplementedSoonPage></FeatureToBeImplementedSoonPage>
  );
}
